import React, { useState, useEffect } from 'react';
import termosTexto from '../assets/termos.txt';
import '../styles/termos.css';

const TermosModal = ({ show, onAccept, loading }) => {
  const [aceitouTermos, setAceitouTermos] = useState(false);
  const [conteudoTermos, setConteudoTermos] = useState('');

  useEffect(() => {
    // Carregar o arquivo de termos
    fetch(termosTexto)
      .then(response => response.text())
      .then(text => setConteudoTermos(text))
      .catch(err => console.error('Erro ao carregar termos:', err));
  }, []);

  useEffect(() => {
    if (show) {
      document.body.classList.add('modal-open');
      setAceitouTermos(false);
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [show]);

  // Função para formatar o conteúdo
  const formatarConteudo = (texto) => {
    return texto.split('\n').map((linha, index) => {
      // Detectar títulos (MAIÚSCULAS)
      if (linha.trim() && linha === linha.toUpperCase() && linha.length > 10) {
        return (
          <h6 key={index} className="termo-titulo-modal mt-3 mb-2">
            {linha}
          </h6>
        );
      }
      
      // Detectar subtítulos (começam com números como "1.", "1.1.", "38.1.")
      if (/^\d+\./.test(linha.trim())) {
        return (
          <p key={index} className="termo-item-modal mb-2">
            <strong>{linha}</strong>
          </p>
        );
      }
      
      // Detectar itens de lista (começam com *)
      if (linha.trim().startsWith('*')) {
        return (
          <li key={index} className="termo-lista-item-modal mb-1">
            {linha.replace('*', '').trim()}
          </li>
        );
      }
      
      // Linhas vazias
      if (!linha.trim()) {
        return <div key={index} style={{height: '8px'}}></div>;
      }
      
      // Texto normal
      return (
        <p key={index} className="termo-paragrafo-modal mb-1">
          {linha}
        </p>
      );
    });
  };

  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>

      <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 1050 }} role="dialog">
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header" style={{marginLeft: '-1rem', backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
              <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                <i className="fas fa-file-contract me-2" style={{ color: '#212529' }}></i>
                Termos de Uso e Política de Privacidade
              </h5>
            </div>
            
            <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
              {/* Conteúdo Formatado */}
              <div className="termos-content-modal">
                {formatarConteudo(conteudoTermos)}
              </div>

              <hr className="my-4" />

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="aceitarTermos"
                  checked={aceitouTermos}
                  onChange={(e) => setAceitouTermos(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="aceitarTermos">
                  <strong>
                    Li e concordo com os Termos de Uso e Política de Privacidade
                  </strong>
                </label>
              </div>
            </div>
            
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={onAccept}
                disabled={!aceitouTermos || loading}
                style={{ minWidth: '150px' }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Processando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-check me-2"></i>
                    Aceitar e Continuar
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermosModal;